import { getParameterByName } from '../utility/queryStringHelper';

export function isInContext(url) {
  const sdkMeta = getParameterByName('sdkMeta', url);

  return sdkMeta || (window && window.xprops);
}

export function onComplete(postBackData, redirectUrl) {
  if (window && window.xprops && window.xprops.onComplete) {
    window.xprops.onComplete({
      postBackData,
      redirectUrl,
    });
  }
}

export function onCancel(redirectUrl) {
  if (window && window.xprops && window.xprops.onCancel) {
    window.xprops.onCancel({
      redirectUrl,
    });
  }
}

export function closeWindow() {
  if (window && window.xprops && window.xprops.close) {
    window.xprops.close();
  }
}
